import actions from "@/core/store/modules/config/actions";
import getters from "@/core/store/modules/config/getters";
import mutations from "@/core/store/modules/config/mutations";


export default {
    state: {},
    getters,
    mutations,
    actions
}